import React from 'react';

import { Box } from 'app/shared/components/atoms';
import { ButtonsSectionProps } from 'app/shared/components/molecules';

interface Props extends ButtonsSectionProps {
  isAuthModalShowing?: boolean;
  setIsAuthModalShowing?: (isAuthModalShowing: boolean) => void;
  successfulSignIn?: () => void;
}

export const ApplyFlowCheckoutWidgetWrapper: React.FC<
  React.PropsWithChildren<Props>
> = ({ children }) => {
  return (
    <Box data-qaid="event-page-apply-flow-checkout-widget" w="100%">
      {children}
    </Box>
  );
};
